import * as MaterialColors from 'material-ui/styles/colors';

export default {
	sipgateBlack: '#000000',
	sipgateWhite: '#ffffff',
	sipgateGray: '#A1A1A1',
	errorColor: MaterialColors.red400,
};



// WEBPACK FOOTER //
// ./src/styles/Colors.js